var $dfccc3416d8619f2$exports = {};
$dfccc3416d8619f2$exports = {
    "Empty": `Vide`
};


export {$dfccc3416d8619f2$exports as default};
//# sourceMappingURL=fr-FR.mjs.map
